import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DocumentEditorModule } from '@onlyoffice/document-editor-angular';
import { AuthModule } from '@tbtk/auth';
import { STORAGE_STRATEGY_TYPE, StorageModule } from '@tbtk/storage';
import { KeycloakService } from 'keycloak-angular';
//import { SnackbarModule } from '@tbtk/snackbar';
import { SnackbarModule } from 'src/app/libs/snackbar/snackbar.module';
import { configEnvironment } from 'src/config/config';

import { AppComponent } from './app.component';
import { initializer } from './app-init';
import { AppRoutingModule } from './app-routing.module';
import { LoadingComponent } from './components/loading/loading.component';
import { appInitializerFactory, I18nModule } from './i18n.module';
import { AUTH_INTERCEPTOR } from './interceptors/http.interceptor';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { PageWrapperComponent } from './page-wrapper.component';
import { OnlyOfficeComponent } from './pages/storage/onlyoffice/onlyoffice.component';
import { MyStorageService } from './pages/storage/storage.service';
import { AuthStore } from './services/auth.store';
import { EnvironmentSgeUrlService } from './services/environmentSgeUrl.service';
import { LocalStorageService } from './services/local-storage.service';
import { SafeLockService } from './services/safelock.service';

const providers = [AUTH_INTERCEPTOR, AuthStore, LocalStorageService, HttpClient, EnvironmentSgeUrlService, SafeLockService, KeycloakService, MyStorageService];

@NgModule({
  declarations: [AppComponent, OnlyOfficeComponent],
  providers: [
    ...providers,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [HttpClient, EnvironmentSgeUrlService, KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
  ],
  imports: [
    AppRoutingModule,
    LoadingComponent,
    BrowserModule,
    BrowserAnimationsModule,
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    I18nModule,
    StorageModule.forRoot(STORAGE_STRATEGY_TYPE.LOCAL),
    AuthModule.forRoot(configEnvironment.keycloak),
    SnackbarModule,
    DocumentEditorModule,
    PageWrapperComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
